import { render, staticRenderFns } from "./MyRemoveDropDownMenuItem.vue?vue&type=template&id=d9dc7e30&"
import script from "./MyRemoveDropDownMenuItem.vue?vue&type=script&lang=js&"
export * from "./MyRemoveDropDownMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MyRemoveDropDownMenuItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9dc7e30')) {
      api.createRecord('d9dc7e30', component.options)
    } else {
      api.reload('d9dc7e30', component.options)
    }
    module.hot.accept("./MyRemoveDropDownMenuItem.vue?vue&type=template&id=d9dc7e30&", function () {
      api.rerender('d9dc7e30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/menu/MyRemoveDropDownMenuItem.vue"
export default component.exports